/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Box, Button, Center, CloseButton, Flex, Grid, GridItem, HStack, Image, Spinner, Stack, Tabs, Text, useToast, VStack, TabList, css, Select, Checkbox } from '@chakra-ui/react';
import { useSteps } from 'chakra-ui-steps';
import { SubmitErrorHandler, SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import InputMask from 'react-input-mask';
import axios from 'axios';
import BlockUi from 'react-block-ui';
import { RiH2, RiThumbUpFill, RiWhatsappFill } from 'react-icons/ri';
import { MdEmail, MdPhone, MdWeb } from 'react-icons/md';
import { components, OptionProps } from 'react-select';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Input } from '../components/Input';
import { ISelectOptions } from '../components/AutoComplete';
import { Chips, ChipsValues } from '../components/Chips';
import { Textarea } from '../components/TextArea';
import { FileUpload } from '../components/FileUpload';
import { toBase64 } from '../utils';

import acLogo from '../assets/img/novo-logo-activebranco 1.png';
import caminhoesparalelos from '../assets/img/caminhoesparalelos.png';
import logoPlaceholder from '../assets/placeholder/logo_placeholder.svg';
import iconEllipse from '../assets/icons/ellipse.svg';
import iconSelectedellipse from '../assets/icons/selectedellipse.svg';
import backgroundLeft from '../assets/img/background-left.png';

import bunzlLogo from '../assets/img/clientslogosnews/bunzl.svg';
import jasmineLogo from '../assets/img/clientslogosnews/jasmine.svg';
import legrandLogo from '../assets/img/clientslogosnews/legrand.svg';
import peccinLogo from '../assets/img/clientslogosnews/peccin.svg';
import restoqueLogo from '../assets/img/clientslogosnews/restoque.svg';
import danevaLogo from '../assets/img/clientslogosnews/daneva.svg';
import dudalinaLogo from '../assets/img/clientslogosnews/dudalina.svg';
import johnjohnLogo from '../assets/img/clientslogosnews/johnjohn.svg';
import skLogo from '../assets/img/clientslogosnews/sk.svg';
import unisysLogo from '../assets/img/clientslogosnews/unisys.svg';
import vedacitLogo from '../assets/img/clientslogosnews/vedacit.svg';
import doriLogo from '../assets/img/clientslogosnews/dori.svg';
import lineaLogo from '../assets/img/clientslogosnews/linea.svg';
import trackLogo from '../assets/img/clientslogosnews/track.svg';
import { SelectInput } from '../components/Select';

SwiperCore.use([Autoplay, Navigation]);

type BuscaCEP = {
  Area_Cidade_Km2: number;
  BACEN: string;
  Bairro: string;
  CEP: string;
  Cidade: string;
  DDD: number;
  Data_Registro: string;
  IBGE_Cidade: string;
  IBGE_UF: string;
  Latitude: number;
  Logradouro: string;
  Longitude: number;
  Pais: string;
  Registro_Localizado: boolean;
  UF: string;
};

type BuscaCNPJ = {
  status: boolean;
  return: string;
  result: {
    numero_de_inscricao: string;
    tipo: string;
    abertura: string;
    nome: string;
    fantasia: string;
    porte: string;
    natureza_juridica: string;
    logradouro: string;
    numero: string;
    complemento: string;
    cep: string;
    bairro: string;
    municipio: string;
    uf: string;
    email: string;
    telefone: string;
    entidade_federativo_responsavel: string;
    situacao: string;
    motivo_situacao_cadastral: string;
    dt_situacao_cadastral: string;
    situacao_especial: string;
    data_situacao_especial: string;
    capital_social: string;
    quadro_socios: string[];
    quadro_de_socios: string[];
  };
};

type CadastroTransportadoraForm = {
  transportador: {
    cnpj: string;
    razaoSocial: string;
    nomeFantasia: string;
    inscricaoEstadual: string;
    telefone: string;
    logo?: File;
    site: string;
    endereco: {
      cep: string;
      logradouro: string;
      numero: string;
      complemento: string;
      bairro: string;
      cidade: string;
      uf: string;
    };
  };
  especialidade: ChipsValues[];
  tipoProduto: ChipsValues[];
  tipoVeiculo: ChipsValues[];
  certificados: ChipsValues[];
  localColetaTipo: string;
  localColeta: ChipsValues[];
  localEntregaTipo: string;
  localEntrega: ChipsValues[];
  pesoMaximo: number;
  observacoesGerais: string;
  contato: {
    nome: string;
    nometransportador: string;
    email: string;
    emailtransportador: string;
    telefone: string;
    telefonetransportador: string;
    ramal: string;
    celular: string;
    cargo: string;
  };
  clientesPrincipais: ChipsValues[];
};

type ReseponseObject = {
  Descricao: string;
  value: string;
  DescricaoMinima?: string;
};

const OptionLocalidade = ({ data, ...rest }: OptionProps<ISelectOptions>) => {
  const { origem } = data.detalhes as { origem: string };

  return (
    <components.Option data={data} {...rest}>
      <HStack justify="space-between">
        <Text fontSize="sm" textTransform="uppercase">
          {data.label}
        </Text>
        <Text fontSize="xs" color="#D1D1D1">
          {origem}
        </Text>
      </HStack>
    </components.Option>
  );
};

function CadastroTransportadoraFreteApp(): JSX.Element {
  const [especialidadesOpcoes, setEspecialidadesOpcoes] = useState<ISelectOptions[]>([]);
  const [tipoProdutosOpcoes, setTipoProdutosOpcoes] = useState<ISelectOptions[]>([]);
  const [tipoVeiculosOpcoes, setTipoVeiculosOpcoes] = useState<ISelectOptions[]>([]);
  const [certificadosOpcoes, setCertificadosOpcoes] = useState<ISelectOptions[]>([]);
  const [locaisOpcoesColeta, setLocaisOpcoesColeta] = useState<ISelectOptions[]>([]);
  const [locaisOpcoesEntrega, setLocaisOpcoesEntrega] = useState<ISelectOptions[]>([]);
  const [contatoCargo, setContatoCargo] = useState<ISelectOptions[]>([]);
  const [loadingReceita, setLoadingReceita] = useState<boolean>(false);
  const [loadingCep, setLoadingCEP] = useState<boolean>(false);
  const [buscaNaReceita, setBuscaNaReceita] = useState<boolean>(true);
  const [dadosReceita, setDadosReceita] = useState<boolean>(false);
  const [razaoSocialReceita, setRazaoSocialReceita] = useState<boolean>(false);
  const [nomeFantasiaReceita, setNomeFantasiaReceita] = useState<boolean>(false);
  const [cepReceita, setCepReceita] = useState<boolean>(false);
  const [logradouroReceita, setLogradouroReceita] = useState<boolean>(false);
  const [numeroReceita, setNumeroReceita] = useState<boolean>(false);
  const [bairroReceita, setBairroReceita] = useState<boolean>(false);
  const [cidadeReceita, setCidadeReceita] = useState<boolean>(false);
  const [ufReceita, setUfReceita] = useState<boolean>(false);
  const [logoPreview, setLogoPreview] = useState<string | undefined>();
  const [inputColeta, setInputColeta] = useState<string>('');
  const [inputEntrega, setInputEntrega] = useState<string>('');
  const [inputCargo, setInputCargo] = useState<string>('');
  const [emailConfirmacao, setEmailConfirmacao] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [disabledButtonSubmit, setDisabledButtonSubmit] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);
  const [contatoComercial, setContatoComercial] = useState<boolean>(false);
  const [principaisClienteOpcoes, setPrincipaisClienteOpcoes] = useState<ISelectOptions[]>([]);

  const toast = useToast();

  // useEffect(() => {
  //   async function searchOpcoes() {
  //     const response = await axios.get<string[]>(`${process.env.REACT_APP_OS_URL}/Cliente/Especializacao`);
  //     setEspecialidadesOpcoes(response.data.map(opcao => ({ label: opcao, value: opcao })));
  //   }

  //   searchOpcoes();
  // }, []);

  // useEffect(() => {
  //   async function searchOpcoes() {
  //     const response = await axios.get<string[]>(`${process.env.REACT_APP_OS_URL}/Cliente/TipoProduto`);
  //     setTipoProdutosOpcoes(response.data.map(opcao => ({ label: opcao, value: opcao })));
  //   }

  //   searchOpcoes();
  // }, []);

  useEffect(() => {
    async function searchOpcoes() {
      const response = await axios.get<string[]>(`${process.env.REACT_APP_OS_URL}/Cliente/TipoVeiculo`);
      setTipoVeiculosOpcoes(response.data.map(opcao => ({ label: opcao, value: opcao })));
    }

    searchOpcoes();
  }, []);

  useEffect(() => {
    async function searchOpcoes() {
      const response = await axios.get<ReseponseObject[]>(`${process.env.REACT_APP_OS_URL}/Cliente/Externo/Certificado`);
      setCertificadosOpcoes(response.data.map(opcao => ({ label: opcao.Descricao, value: opcao.Descricao, descricaoMinima: opcao.DescricaoMinima })));
    }

    searchOpcoes();
  }, []);

  useEffect(() => {
    async function searchOpcoes() {
      const response = await axios.get<ReseponseObject[]>(`${process.env.REACT_APP_OS_URL}/Cargo/Tipo/Externo`);
      // setContatoCargo(response.data.map(opcao => ({ label: opcao.Descricao, value: opcao.value })));
      setContatoCargo([
        { label: 'Diretor / CEO', value: '14' },
        { label: 'Gerente', value: '13' },
        { label: 'Coordenador / Supervisor', value: '10' },
        { label: 'Analista', value: '6' },
        { label: 'Assistente / Auxiliar', value: '6' },
        { label: 'Estagiário / Estudante', value: '12' },
        { label: 'Outro', value: '22' },
      ]);
    }

    searchOpcoes();
  }, []);

  useEffect(() => {
    async function searchRegionEstadoCidade() {
      const requestRegiao = axios.get<
        {
          ID: number;
          Sigla: string;
          Descricao: string;
        }[]
      >(`${process.env.REACT_APP_OS_URL}/Regiao/${inputColeta}`);

      const requestEstado = await axios.get<
        {
          Estado_ID: number;
          Sigla: string;
          Descricao: string;
        }[]
      >(`${process.env.REACT_APP_OS_URL}/Estado/${inputColeta}`);

      const requestCidade = await axios.get<
        {
          Cidade_ID: number;
          Descricao: string;
        }[]
      >(`${process.env.REACT_APP_OS_URL}/Cidade/${inputColeta}`);

      Promise.all([requestRegiao, requestEstado, requestCidade]).then(([responseRegiao, responseEstado, responseCidade]) => {
        setLocaisOpcoesColeta([
          ...responseRegiao.data.map<ISelectOptions>(regiao => ({
            label: regiao.Descricao.charAt(0).toUpperCase() + regiao.Descricao.slice(1).toLowerCase(),
            value: regiao.ID.toString(),
            detalhes: { origem: 'Região' },
          })),
          ...responseEstado.data.map<ISelectOptions>(estado => ({
            label: estado.Descricao.charAt(0).toUpperCase() + estado.Descricao.slice(1).toLowerCase(),
            value: estado.Estado_ID.toString(),
            detalhes: { origem: 'Estado' },
          })),
          ...responseCidade.data.map<ISelectOptions>(cidade => ({
            label: cidade.Descricao.charAt(0).toUpperCase() + cidade.Descricao.slice(1).toLowerCase(),
            value: cidade.Cidade_ID.toString(),
            detalhes: { origem: 'Cidade' },
          })),
        ]);
      });
    }

    searchRegionEstadoCidade();
  }, [inputColeta]);

  useEffect(() => {
    async function searchRegionEstadoCidade() {
      const requestRegiao = axios.get<
        {
          ID: number;
          Sigla: string;
          Descricao: string;
        }[]
      >(`${process.env.REACT_APP_OS_URL}/Regiao/${inputEntrega}`);

      const requestEstado = await axios.get<
        {
          Estado_ID: number;
          Sigla: string;
          Descricao: string;
        }[]
      >(`${process.env.REACT_APP_OS_URL}/Estado/${inputEntrega}`);

      const requestCidade = await axios.get<
        {
          Cidade_ID: number;
          Descricao: string;
        }[]
      >(`${process.env.REACT_APP_OS_URL}/Cidade/${inputEntrega}`);

      Promise.all([requestRegiao, requestEstado, requestCidade]).then(([responseRegiao, responseEstado, responseCidade]) => {
        setLocaisOpcoesEntrega([
          ...responseRegiao.data.map<ISelectOptions>(regiao => ({
            label: regiao.Descricao.charAt(0).toUpperCase() + regiao.Descricao.slice(1).toLowerCase(),
            value: regiao.ID.toString(),
            detalhes: { origem: 'Região' },
          })),
          ...responseEstado.data.map<ISelectOptions>(estado => ({
            label: estado.Descricao.charAt(0).toUpperCase() + estado.Descricao.slice(1).toLowerCase(),
            value: estado.Estado_ID.toString(),
            detalhes: { origem: 'Estado' },
          })),
          ...responseCidade.data.map<ISelectOptions>(cidade => ({
            label: cidade.Descricao.charAt(0).toUpperCase() + cidade.Descricao.slice(1).toLowerCase(),
            value: cidade.Cidade_ID.toString(),
            detalhes: { origem: 'Cidade' },
          })),
        ]);
      });
    }

    searchRegionEstadoCidade();
  }, [inputEntrega]);

  const { nextStep, prevStep, setStep, activeStep } = useSteps({
    initialStep: 0,
  });

  useEffect(() => {
    const ele = document.querySelector('#root > div > div:nth-child(2)');
    if (ele && activeStep >= 1 && activeStep < 5) {
      ele.scrollIntoView();
    }
  }, [activeStep]);

  const transportadorFormSchema = yup.object<Partial<Record<keyof CadastroTransportadoraForm, yup.AnySchema>>>({
    transportador: yup.object<Partial<Record<keyof CadastroTransportadoraForm['transportador'], yup.AnySchema>>>({
      cnpj: yup.string().required('Campo obrigatório').cnpj('CNPJ inválido'),
      razaoSocial: yup.string().required('Campo obrigatório'),
      nomeFantasia: yup.string().required('Campo obrigatório'),
      inscricaoEstadual: yup.string(),
      site: yup
        .string()
        .matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/, { excludeEmptyString: true, message: 'URL inválida' })
        .notRequired(),
      endereco: yup.object<Partial<Record<keyof CadastroTransportadoraForm['transportador']['endereco'], yup.AnySchema>>>({
        cep: yup.string().required('Campo obrigatório'),
        logradouro: yup.string().required('Campo obrigatório'),
        numero: yup.string().required('Campo obrigatório'),
        bairro: yup.string().required('Campo obrigatório'),
        cidade: yup.string().required('Campo obrigatório'),
        uf: yup.string().required('Campo obrigatório'),
      }),
    }),
    especialidade: yup.array(),
    tipoProduto: yup.array(),
    tipoVeiculo: yup.array(),
    certificados: yup.array(),
    localColetaTipo: yup.string(),
    localColeta: yup.array(),
    localEntregaTipo: yup.string(),
    localEntrega: yup.array(),
    pesoMaximo: yup.number().typeError('Campo obrigatório').required('Campo obrigatório'),
    observacoesGerais: yup.string().required('Campo obrigatório'),
    contato: yup.object<Partial<Record<keyof CadastroTransportadoraForm['contato'], yup.AnySchema>>>({
      nome: yup.string().required('Campo obrigatório'),
      nometransportador: yup.string().required('Campo obrigatório'),
      email: yup.string().required('Campo obrigatório').email('Email inválido'),
      emailtransportador: yup.string().required('Campo obrigatório').email('Email inválido'),
      celular: yup.string().required('Campo obrigatório'),
      telefone: yup.string().required('Campo obrigatório'),
      telefonetransportador: yup.string().required('Campo obrigatório'),
      cargo: yup.string(),
    }),
    clientesPrincipais: yup.array()
  });

  const { register, handleSubmit, formState, trigger, setValue, getValues, control, watch } = useForm<CadastroTransportadoraForm>({
    resolver: yupResolver(transportadorFormSchema),
    defaultValues: {
      localColetaTipo: 'estado',
      localEntregaTipo: 'estado',
    },
  });

  const especialidadeArray = useFieldArray({
    control,
    name: 'especialidade',
  });

  const tipoProdutoArray = useFieldArray({
    control,
    name: 'tipoProduto',
  });

  const tipoVeiculoArray = useFieldArray({
    control,
    name: 'tipoVeiculo',
  });

  const certificadoArray = useFieldArray({
    control,
    name: 'certificados',
  });

  const coletaArray = useFieldArray({
    control,
    name: 'localColeta',
  });

  const entregaArray = useFieldArray({
    control,
    name: 'localEntrega',
  });

  const principaisClienteOpcoesArray = useFieldArray({
    control,
    name: 'clientesPrincipais',
  });

  const searchCNPJ = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      const documento = e.currentTarget.value.replace(/\D/g, '');

      if (documento.length === 14) {
        if (buscaNaReceita || getValues('transportador.cnpj').replace(/\D/g, '') !== documento) {
          setLoadingReceita(true);
          try {
            const { data } = await axios.get<BuscaCNPJ>(`${process.env.REACT_APP_BUSCACNPJ_URL}/?cnpj=${documento}&token=${process.env.REACT_APP_BUSCACNPJ_TOKEN}`);
            setBuscaNaReceita(false);

            if (data.status) {
              if (data.result.nome) {
                setValue('transportador.razaoSocial', data.result.nome);
                setRazaoSocialReceita(true);
              } else {
                setRazaoSocialReceita(false);
              }

              if (data.result.fantasia) {
                setValue('transportador.nomeFantasia', data.result.fantasia);
                setNomeFantasiaReceita(true);
              } else {
                setNomeFantasiaReceita(false);
              }

              if (data.result.cep.replace(/\D/g, '').length === 8) {
                setValue('transportador.endereco.cep', data.result.cep.replace(/\D/g, ''));
                setCepReceita(true);
              } else {
                setCepReceita(false);
              }

              if (data.result.logradouro) {
                setValue('transportador.endereco.logradouro', data.result.logradouro);
                setLogradouroReceita(true);
              } else {
                setLogradouroReceita(false);
              }

              if (data.result.numero) {
                setValue('transportador.endereco.numero', data.result.numero);
                setNumeroReceita(true);
              } else {
                setNumeroReceita(false);
              }

              if (data.result.bairro) {
                setValue('transportador.endereco.bairro', data.result.bairro);
                setBairroReceita(true);
              } else {
                setBairroReceita(false);
              }

              if (data.result.municipio) {
                setValue('transportador.endereco.cidade', data.result.municipio);
                setCidadeReceita(true);
              } else {
                setCidadeReceita(false);
              }

              if (data.result.uf) {
                setValue('transportador.endereco.uf', data.result.uf);
                setUfReceita(true);
              } else {
                setUfReceita(false);
              }

              setDadosReceita(true);
            }
            // eslint-disable-next-line prettier/prettier
          } catch { }
          setLoadingReceita(false);
        }
      } else {
        setBuscaNaReceita(true);
        setRazaoSocialReceita(false);
        setNomeFantasiaReceita(false);
        setCepReceita(false);
        setLogradouroReceita(false);
        setNumeroReceita(false);
        setBairroReceita(false);
        setCidadeReceita(false);
        setUfReceita(false);
      }
    },
    [buscaNaReceita, getValues, setValue],
  );

  const searchCEP = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      const cep = e.target.value.replace(/\D/g, '');

      if (cep.length === 8 && !dadosReceita) {
        setLoadingCEP(true);
        try {
          const { data } = await axios.get<BuscaCEP>(`${process.env.REACT_APP_BUSCACEP_URL}?cep=${cep}`);

          setValue('transportador.endereco.logradouro', data.Logradouro);
          setValue('transportador.endereco.bairro', data.Bairro);
          setValue('transportador.endereco.cidade', data.Cidade);
          setValue('transportador.endereco.uf', data.UF);
          // eslint-disable-next-line prettier/prettier
        } catch { }
        setLoadingCEP(false);
      }
    },
    [dadosReceita, setValue],
  );

  const cargoArray = useFieldArray({
    control,
    name: 'tipoVeiculo',
  });

  const handleSubmitSuccess: SubmitHandler<CadastroTransportadoraForm> = useCallback(
    async form => {
      setLoading(true);
      setDisabledButtonSubmit(true);

      try {
        const data = {
          SiglaTipoPessoa: 'J',
          Documento: form.transportador.cnpj.replace(/\D/g, ''),
          IEst: form.transportador.inscricaoEstadual,
          Nome: form.transportador.nomeFantasia,
          RazaoSocial: form.transportador.razaoSocial.slice(0, 60),
          NomeImpressao: form.transportador.nomeFantasia,
          LogoBase64: form.transportador.logo ? await toBase64(form.transportador.logo) : undefined,
          WebSite: form.transportador.site,
          Fone: form.transportador.telefone.replace(/\D/g, ''),
          Cep: form.transportador.endereco.cep.replace(/\D/g, ''),
          Endereco: form.transportador.endereco.logradouro,
          Numero: form.transportador.endereco.numero,
          Complemento: form.transportador.endereco.complemento,
          Bairro: form.transportador.endereco.bairro,
          Cidade: {
            Descricao: form.transportador.endereco.cidade.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          },
          Estado: {
            Descricao: form.transportador.endereco.uf,
          },
          Pais: {
            Pais_ID: '30',
          },
          Observacao: form.observacoesGerais,
          PesoMaximo: form.pesoMaximo,
          Contato: form.contato.nome,
          Email: form.contato.email,
          Cargo: {
            Descricao: getValues('contato.cargo'),
          },
          Contatos_Empresa: [
            {
              Contato: form.contato.nometransportador,
              Email: form.contato.emailtransportador,
              Fone: form.contato.telefonetransportador.replace(/\D/g, ''),
              Ramal: form.contato.ramal,
              Celular: form.contato.celular.replace(/\D/g, ''),
            },
          ],
          Especialidade: [] as string[],
          TipoProduto: [] as string[],
          TipoVeiculo: [] as string[],
          Certificados: [] as { Descricao: string; ArquivoBase64?: string }[],
          LocalColeta: [] as { Local_ID: string; Descricao: string; TipoLocal: string }[],
          LocalEntrega: [] as { Local_ID: string; Descricao: string; TipoLocal: string }[],
          AtualizarCadastro: true,
          Cadastrar_ContatoComercial: true,
          Contatos_Comercial: [
            {
              Contato: form.contato.nome,
              Email: form.contato.email,
              Fone: form.contato.telefone.replace(/\D/g, ''),
              Ramal: form.contato.ramal,
              Celular: form.contato.celular.replace(/\D/g, ''),
            },
          ],
          ClientesPrincipais: [] as string[]
        };

        if (form.especialidade?.length) {
          for (let i = 0; i < form.especialidade.length; i++) {
            const especialidade = form.especialidade[i];
            data.Especialidade.push(especialidade.label);
          }
        }

        if (form.tipoProduto?.length) {
          for (let i = 0; i < form.tipoProduto.length; i++) {
            const tipoProduto = form.tipoProduto[i];
            data.TipoProduto.push(tipoProduto.label);
          }
        }

        if (form.tipoVeiculo?.length) {
          for (let i = 0; i < form.tipoVeiculo.length; i++) {
            const tipoVeiculo = form.tipoVeiculo[i];
            data.TipoVeiculo.push(tipoVeiculo.label);
          }
        }

        if (form.certificados?.length) {
          const certificadosPromises = [] as Promise<number | void>[];
          for (let i = 0; i < form.certificados.length; i++) {
            const certificados = form.certificados[i];
            if (certificados.file) {
              certificadosPromises.push(toBase64(certificados.file).then(base64 => data.Certificados.push({ Descricao: certificados.label, ArquivoBase64: base64 })));
            } else {
              data.Certificados.push({ Descricao: certificados.label });
            }
          }

          await Promise.all(certificadosPromises);
        }

        if (form.localColeta?.length) {
          for (let i = 0; i < form.localColeta.length; i++) {
            const localColeta = form.localColeta[i];
            const { origem } = localColeta.detalhes as { origem: string };

            data.LocalColeta.push({
              Local_ID: localColeta.value,
              Descricao: localColeta.label,
              TipoLocal: origem,
            });
          }
        }

        if (form.localEntrega?.length) {
          for (let i = 0; i < form.localEntrega.length; i++) {
            const localEntrega = form.localEntrega[i];
            const { origem } = localEntrega.detalhes as { origem: string };

            data.LocalEntrega.push({
              Local_ID: localEntrega.value,
              Descricao: localEntrega.label,
              TipoLocal: origem,
            });
          }
        }

        if (form.clientesPrincipais?.length) {
          for (let i = 0; i < form.clientesPrincipais.length; i++) {
            const clientePrincipal = form.clientesPrincipais[i];
            data.ClientesPrincipais.push(clientePrincipal.label);
          }
        }

        const response = await axios.post(`${process.env.REACT_APP_OS_URL}/Empresa/Filial/SalvaEmpresaFilial/Temporario`, data);
        setDisabledButtonSubmit(false);

        if (response.status === 200) {
          if (response.data[0] === -1) {
            if (response.headers['email-confirmacao']) {
              const email = response.headers['email-confirmacao'].replace(/(\w{3})[\w.-]+@([\w.]+\w)/, '$1***@$2');
              setEmailConfirmacao(email);
            }
            setStep(6);
          } else {
            setStep(5);
          }
        }
      } catch (error) {
        setDisabledButtonSubmit(false);
        toast({
          title: 'Ocorreu algo inesperado, por favor tente novamente.',
          position: 'top-right',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    },
    [setStep, toast, getValues],
  );

  const handleSubmitError: SubmitErrorHandler<CadastroTransportadoraForm> = useCallback(() => {
    toast({
      title: 'Não foi possível enviar os dados para cadastrar a Transportadora.',
      description: 'Por favor, verifique os campos informados.',
      position: 'top-right',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  }, [toast]);

  const handleNext = useCallback(async () => {
    let isValid = false;

    switch (activeStep) {
      case 0:
        isValid = await trigger([
          'transportador.cnpj',
          'transportador.razaoSocial',
          'transportador.nomeFantasia',
          'transportador.site',
          'transportador.inscricaoEstadual',
          'contato.nometransportador',
          'contato.emailtransportador',
        ]);
        break;
      case 1:
        isValid = await trigger([
          'transportador.endereco.cep',
          'transportador.endereco.logradouro',
          'transportador.endereco.numero',
          'transportador.endereco.bairro',
          'transportador.endereco.cidade',
          'transportador.endereco.uf',
        ]);
        break;
      case 2:
        isValid = await trigger(['pesoMaximo', 'observacoesGerais']);
        break;
      case 3:
        isValid = await trigger(['contato.nome', 'contato.email', 'contato.celular']);
        break;
      case 4:
        isValid = true;
        break;
      default:
        break;
    }

    if (isValid) {
      if (activeStep === 4) {
        handleSubmit(handleSubmitSuccess, handleSubmitError)();
      } else {
        nextStep();
      }
    }
  }, [activeStep, handleSubmit, handleSubmitError, handleSubmitSuccess, nextStep, trigger]);

  watch(['localColetaTipo', 'localEntregaTipo', 'transportador.logo', 'transportador.telefone']);

  const logo = getValues('transportador.logo');
  useEffect(() => {
    if (!logo) {
      setLogoPreview(undefined);
      return;
    }
    setLogoPreview(URL.createObjectURL(logo));
  }, [logo]);

  const changeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContatoComercial(e.target.checked);
    if (e.target.checked) {
      setValue('contato.nome', getValues('contato.nometransportador'));
      setValue('contato.email', getValues('contato.emailtransportador'));
      setValue('contato.telefone', getValues('contato.telefonetransportador'));
    } else {
      setValue('contato.nome', '');
      setValue('contato.email', '');
      setValue('contato.telefone', '');
    }
  };

  return (
    <Stack w="100%" h="100%" spacing={0} direction={{ base: 'column', lg: 'row' }} >
      <VStack hidden={activeStep >= 5} bg={`url("${backgroundLeft}") no-repeat center center`} bgSize="cover" flex="1" h="100%" spacing={0} gap="10">
        <VStack mb={{ base: '2', lg: '6' }} h="100%" justify="space-between" spacing={0}>
          <Box mt={{ base: '8', lg: '16' }} mx={{ base: '4', lg: '24' }}>
            <Image src={acLogo} />
            <Text as="h1" color="white" fontSize={{ base: 'lg', lg: '2xl' }} fontWeight="bold" textAlign="start" lineHeight="28px" marginTop={46}>
              DIVULGUE SUA TRANSPORTADORA E CONQUISTE MAIS CLIENTES!
            </Text>
            <Text display={{ base: 'none', lg: 'block' }} mt="2" color="white" fontSize={{ base: 'sm', lg: 'lg' }} textAlign="start">
              Seja visto pelos principais embarcadores do país e aumente suas possibilidades de novos negócios!
            </Text>
          </Box>
          <VStack justify="space-between" spacing={0} gap="20" mt="10">
            <Box className="container-icons-company" mt={[180, 0, 30]}>
              <Text color="#1D1D1D" fontSize={16} fontWeight="bold" textAlign="center" lineHeight="113%" mb="4" textTransform="uppercase">
                Algumas <span className="green-active"> empresas </span> que usam diariamente o <br /> Active OnSupply:
              </Text>
              <Box w={[350, 400, 660]}>
                <Swiper
                  navigation
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                  }}
                  loop
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <Image src={doriLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={lineaLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={trackLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={bunzlLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={jasmineLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={legrandLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={peccinLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={restoqueLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={danevaLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={dudalinaLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={johnjohnLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={peccinLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={skLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={unisysLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={vedacitLogo} alt="logo" h="106px" w={[300, 200, 154]} />
                  </SwiperSlide>
                </Swiper>
              </Box>
            </Box>
          </VStack>
        </VStack>
      </VStack>
      <Flex hidden={activeStep >= 5} flex="1" h="100%" overflow={{ base: 'unset', lg: 'auto' }} style={{ scrollbarGutter: 'stable' }}>
        <Flex mt="2" py={{ base: '8', lg: '16' }} pl={{ base: '8', lg: '16' }} pr={{ base: '4', lg: '10' }} flexDir="column" h="max-content" w="100%" justify="center">
          <Box hidden={activeStep !== 0}>
            <Text fontSize="xl" fontWeight="semibold">
              É de graça mesmo?
            </Text>
            <Text fontSize="sm">
              Sim! Você
              <b> não paga nada para divulgar sua transportadora </b>
              no portal Active OnSupply. É o que chamamos de ganha-ganha: sua empresa vai ter mais visibilidade e nossos clientes, que usam o Active OnSupply, terão mais opções de transportadoras
              qualificadas!
            </Text>
            <Box mt="7">
              {logoPreview ? (
                <HStack align="flex-start">
                  <Image src={logoPreview} alt="logo transportadora" h="134px" onClick={() => document.getElementById('transportador.logo')?.click()} />
                  <CloseButton color="red" onClick={() => setValue('transportador.logo', undefined)} />
                </HStack>
              ) : (
                <Stack direction={['column', 'row']} alignItems="center">
                  <Image src={logoPlaceholder} onClick={() => document.getElementById('transportador.logo')?.click()} mr="6" />
                  {/* <FileUpload control={control} name="transportador.logo" acceptedFileTypes="image/*" placeholder="Clique aqui para adicionar" /> */}
                  <FileUpload control={control} name="transportador.logo" acceptedFileTypes="image/*" placeholder="Clique aqui para adicionar →" fontSizeText="sm" classNameText="btn-adicionar" />
                  Clique aqui para adicionar
                </Stack>
              )}
              <Box mt="3">
                <Text fontSize="sm">Ter um logotipo é essencial para consolidação da sua empresa no mercado</Text>
              </Box>
            </Box>
            <BlockUi
              tag="div"
              blocking={loadingReceita}
              message="Buscando dados na Receita..."
              loader={
                <Box>
                  <Spinner size="lg" color="onsupply.500" thickness="4px" />
                </Box>
              }
            >
              <Box mt="12">
                <VStack spacing="0" gap="15">
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input label="Qual é o seu nome?**" autoFocus error={formState.errors.contato?.nometransportador} {...register('contato.nometransportador')} />
                    <SelectInput
                      showBorder
                      colorScheme="onsupply"
                      options={contatoCargo}
                      name="contato.cargo"
                      label="Qual é o seu cargo?*"
                      error={formState.errors.contato?.cargo}
                      onChange={(e: any) => setValue('contato.cargo', e.label)}
                    />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input label="E-mail*" error={formState.errors.contato?.emailtransportador} {...register('contato.emailtransportador')} />
                    <Input as={InputMask} label="Telefone" mask="(99) 9999-9999" maskChar="" {...register('contato.telefonetransportador')} />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input
                      {...register('transportador.cnpj')}
                      as={InputMask}
                      colorScheme="red"
                      label="CNPJ*"
                      mask="99.999.999/9999-99"
                      maskChar=""
                      onChange={searchCNPJ}
                      error={formState.errors.transportador?.cnpj}
                    />
                    <Input
                      colorScheme="activeblue"
                      label="Razão Social*"
                      isDisabled={razaoSocialReceita}
                      error={formState.errors.transportador?.razaoSocial}
                      {...register('transportador.razaoSocial')}
                    />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input
                      colorScheme="activeblue"
                      label="Nome Fantasia*"
                      isDisabled={nomeFantasiaReceita}
                      error={formState.errors.transportador?.nomeFantasia}
                      {...register('transportador.nomeFantasia')}
                    />
                    <Input colorScheme="active_blue" label="Inscrição Estadual" error={formState.errors.transportador?.inscricaoEstadual} {...register('transportador.inscricaoEstadual')} />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input colorScheme="active_blue" label="Site da sua Transportadora" error={formState.errors.transportador?.site} {...register('transportador.site')} />
                  </Stack>
                </VStack>
              </Box>
            </BlockUi>
          </Box>
          <Box hidden={activeStep !== 1} mt={[50, 0, 0]}>
            <Text fontSize="xl" fontWeight="semibold">
              Informe o endereço da sua transportadora
            </Text>
            <BlockUi
              tag="div"
              blocking={loadingCep}
              message="Buscando dados do CEP..."
              loader={
                <Box>
                  <Spinner size="lg" color="onsupply.500" thickness="4px" />
                </Box>
              }
            >
              <Box mt="4">
                <VStack spacing="0" gap="15">
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input
                      {...register('transportador.endereco.cep')}
                      as={InputMask}
                      mask="99999-999"
                      maskChar=""
                      autoFocus
                      onChange={searchCEP}
                      colorScheme="onsupply"
                      label="CEP*"
                      isDisabled={cepReceita}
                      error={formState.errors.transportador?.endereco?.cep}
                    />
                    <Input
                      colorScheme="onsupply"
                      label="Logradouro*"
                      isDisabled={logradouroReceita}
                      error={formState.errors.transportador?.endereco?.logradouro}
                      {...register('transportador.endereco.logradouro')}
                    />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input colorScheme="onsupply" label="Número*" isDisabled={numeroReceita} error={formState.errors.transportador?.endereco?.numero} {...register('transportador.endereco.numero')} />
                    <Input label="Complemento" error={formState.errors.transportador?.endereco?.complemento} {...register('transportador.endereco.complemento')} />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input colorScheme="onsupply" label="Bairro*" isDisabled={bairroReceita} error={formState.errors.transportador?.endereco?.bairro} {...register('transportador.endereco.bairro')} />
                    <Input colorScheme="onsupply" label="Cidade*" isDisabled={cidadeReceita} error={formState.errors.transportador?.endereco?.cidade} {...register('transportador.endereco.cidade')} />
                  </Stack>
                  <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                    <Input colorScheme="onsupply" label="UF*" isDisabled={ufReceita} error={formState.errors.transportador?.endereco?.uf} {...register('transportador.endereco.uf')} />
                    <Input
                      as={InputMask}
                      mask={getValues('transportador.telefone')?.replace(/\D/g, '')?.length <= 10 ? '(99) 9999-99999' : '(99) 99999-9999'}
                      maskChar=""
                      colorScheme="onsupply"
                      label="Telefone"
                      error={formState.errors.transportador?.telefone}
                      {...register('transportador.telefone')}
                    />
                  </Stack>
                </VStack>
              </Box>
            </BlockUi>
          </Box>

          <Box hidden={activeStep !== 2} mt={[50, 0, 0]}>
            <Text fontSize="xl" fontWeight="semibold">
              Para ser encontrado pelo cliente certo, informe:
            </Text>
            <Box mt="4">
              <VStack spacing="0" gap="11">
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Chips
                    creatable
                    label="Suas principais especialidades"
                    autoFocus
                    name="especialidades"
                    options={especialidadesOpcoes}
                    {...especialidadeArray}
                    viewTooltip
                    tooltipLabel="Explique aos clientes qual é o principal foco da sua transportadora. Ex: carga dedicada, carga fracionada, entrega rápida, etc."
                    placeholder="Cadastre..."
                  />
                </Stack>
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Chips
                    creatable
                    label="Seus principais clientes"
                    autoFocus
                    name="especialidades"
                    options={principaisClienteOpcoes}
                    {...principaisClienteOpcoesArray}
                    viewTooltip
                    tooltipLabel="Cadastre seus principais clientes."
                    placeholder="Cadastre..."
                  />
                </Stack>
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Chips creatable label="Tipos de Veículos" name="tipoveiculos" options={tipoVeiculosOpcoes} {...tipoVeiculoArray} />
                  <Chips
                    creatable
                    label="Tipos de produtos transportados"
                    name="tipoprodutos"
                    options={tipoProdutosOpcoes}
                    {...tipoProdutoArray}
                    viewTooltip
                    tooltipLabel="Digite os principais produtos que você transporta. Ex: alimentos perecíveis, alimentos não perecíveis, alimentos congelados, etc."
                    placeholder="Cadastre..."
                  />
                </Stack>
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Chips label="Quais documentações e certificações você possui?" name="certificados" options={certificadosOpcoes} uploadFile {...certificadoArray} />
                  <Input type="number" min={0} onWheel={event => event.currentTarget.blur()} label="Peso máximo transportado*" error={formState.errors.pesoMaximo} {...register('pesoMaximo')} />
                </Stack>
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Chips
                    label="Locais de Coleta"
                    onInputChange={input => setInputColeta(input)}
                    optionRender={OptionLocalidade}
                    placeholder="Região, Estado ou Cidade"
                    name="localColeta"
                    options={locaisOpcoesColeta}
                    {...coletaArray}
                  />
                  <Chips
                    label="Locais de Entrega"
                    onInputChange={input => setInputEntrega(input)}
                    optionRender={OptionLocalidade}
                    placeholder="Região, Estado ou Cidade"
                    name="localEntrega"
                    options={locaisOpcoesEntrega}
                    {...entregaArray}
                  />
                </Stack>
                <HStack w="100%" gap="25" spacing="0" align="flex-start">
                  <Textarea
                    label="Faça o seu comercial, descreva aqui Porque o Cliente deve te contratar*"
                    isRequired
                    error={formState.errors.observacoesGerais}
                    maxLength={500}
                    {...register('observacoesGerais')}
                    onChange={e => setCount(e.target.value.length)}
                    count={count}
                    viewTooltip
                    tooltipLabel="Escreva sobre as qualidades da sua transportadora,
                    quantidade de veículos ou competências. Muitas transportadoras também descrevem a quantidade de funcionários e a região de atuação."
                  />
                </HStack>
              </VStack>
            </Box>
          </Box>

          <Box hidden={activeStep !== 3} mt={[50, 0, 0]}>
            <Text fontSize="xl" fontWeight="semibold">
              CONTATO COMERCIAL
            </Text>
            <Box mt="3">
              <Text fontSize="sm">Coloque abaixo os dados de quem será o responsável por retornar para os clientes interessados nos seus serviços:</Text>
            </Box>
            <Box mt="4">
              <VStack spacing="0" gap="11">
                <Stack align="flex-start" spacing="0" w="100%" mb={6}>
                  <Checkbox colorScheme="onsupply" onChange={changeCheckbox}>
                    Eu mesmo sou o responsável pelo Comercial da transportadora
                  </Checkbox>
                </Stack>
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Input label="Nome*" autoFocus error={formState.errors.contato?.nome} {...register('contato.nome')} />
                  <Input label="E-mail*" error={formState.errors.contato?.email} {...register('contato.email')} />
                </Stack>
                <Stack direction={{ base: 'column', lg: 'row' }} w="100%" gap={{ base: '11', lg: '25' }} spacing="0" align="flex-start">
                  <Input as={InputMask} colorScheme="onsupply" label="Celular*" mask="(99) 99999-9999" maskChar="" error={formState.errors.contato?.celular} {...register('contato.celular')} />
                  <Input as={InputMask} label="Telefone" mask="(99) 9999-9999" maskChar="" {...register('contato.telefone')} />
                  <Input label="Ramal" {...register('contato.ramal')} />
                </Stack>
              </VStack>
            </Box>
          </Box>

          <Stack hidden={activeStep !== 4}>
            <Text fontSize="xl" fontWeight="semibold">
              Confira se as informações estão corretas:
            </Text>
            <Grid templateColumns="repeat(2, 2fr)" gap={4} mt="2">
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    CNPJ:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.cnpj')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Razão Social:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.razaoSocial')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Nome Fantasia:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.nomeFantasia')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Inscrição Estadual:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.inscricaoEstadual')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Site da sua Transportadora:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.site')}
                  </Text>
                </Box>
              </GridItem>
            </Grid>
            <hr className="hr" />
            <Grid templateColumns="repeat(4, 1fr)" gap={4} mt="2">
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    CEP:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.cep')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Logradouro:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.logradouro')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Número:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.numero')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Complemento:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.complemento')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Bairro:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.bairro')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Cidade:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.cidade')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    UF:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.endereco.uf')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Telefone:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('transportador.telefone')}
                  </Text>
                </Box>
              </GridItem>
            </Grid>
            <hr className="hr" />
            <Grid templateColumns="repeat(2, 2fr)" gap={4} mt="2">
              <GridItem>
                <Text fontSize="sm" fontWeight="semibold">
                  Informe sua principal especialidade:
                </Text>
                <Box overflow={{ base: 'unset', lg: 'auto' }} height={{ base: 'max-content', lg: '100px' }}>
                  {getValues('especialidade')?.map(item => (
                    <Text fontSize="sm" fontWeight="normal">
                      {item.label}
                    </Text>
                  ))}
                </Box>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" fontWeight="semibold">
                  Tipos de Veículos:
                </Text>
                <Box overflow={{ base: 'unset', lg: 'auto' }} height={{ base: 'max-content', lg: '100px' }}>
                  {getValues('tipoVeiculo')?.map(item => (
                    <Text fontSize="sm" fontWeight="normal">
                      {item.label}
                    </Text>
                  ))}
                </Box>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" fontWeight="semibold">
                  Tipos de produtos transportados:
                </Text>
                <Box overflow={{ base: 'unset', lg: 'auto' }} height={{ base: 'max-content', lg: '100px' }}>
                  {getValues('tipoProduto')?.map(item => (
                    <Text fontSize="sm" fontWeight="normal">
                      {item.label}
                    </Text>
                  ))}
                </Box>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" fontWeight="semibold">
                  Informe aqui suas certificações:
                </Text>
                <Box overflow={{ base: 'unset', lg: 'auto' }} height={{ base: 'max-content', lg: '100px' }}>
                  {getValues('certificados')?.map(item => (
                    <Text fontSize="sm" fontWeight="normal">
                      {item.label}
                    </Text>
                  ))}
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Peso máximo Transportado:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('pesoMaximo')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" fontWeight="semibold">
                  Locais de Coleta:
                </Text>
                <Box overflow={{ base: 'unset', lg: 'auto' }} height={{ base: 'max-content', lg: '100px' }}>
                  {getValues('localColeta')?.map(item => (
                    <Text fontSize="sm" fontWeight="normal">
                      {item.label}
                    </Text>
                  ))}
                </Box>
              </GridItem>
              <GridItem>
                <Text fontSize="sm" fontWeight="semibold">
                  Locais de Entrega:
                </Text>
                <Box overflow={{ base: 'unset', lg: 'auto' }} height={{ base: 'max-content', lg: '100px' }}>
                  {getValues('localEntrega')?.map(item => (
                    <Text fontSize="sm" fontWeight="normal">
                      {item.label}
                    </Text>
                  ))}
                </Box>
              </GridItem>
            </Grid>
            <Box mt="4">
              <Text fontSize="sm" fontWeight="semibold">
                Faça o seu comercial, descreva aqui Porque o Cliente deve te contratar:
              </Text>
              <Text fontSize="sm" fontWeight="normal">
                {getValues('observacoesGerais')}
              </Text>
            </Box>
            <hr className="hr" />
            <Grid templateColumns="repeat(2, 2fr)" gap={4} mt="2">
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Nome:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('contato.nome')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    E-mail:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('contato.email')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Celular:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('contato.celular')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Telefone:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('contato.telefone')}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <Box>
                  <Text fontSize="sm" fontWeight="semibold">
                    Ramal:
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    {getValues('contato.ramal')}
                  </Text>
                </Box>
              </GridItem>
            </Grid>
          </Stack>

          <HStack mt="7" mb="9" spacing={0} gap="9px" justify="center">
            <Image src={activeStep === 0 ? iconSelectedellipse : iconEllipse} w={activeStep === 0 ? '12px' : '8px'} h={activeStep === 0 ? '16px' : '8px'} />
            <Image src={activeStep === 1 ? iconSelectedellipse : iconEllipse} w={activeStep === 1 ? '12px' : '8px'} h={activeStep === 1 ? '16px' : '8px'} />
            <Image src={activeStep === 2 ? iconSelectedellipse : iconEllipse} w={activeStep === 2 ? '12px' : '8px'} h={activeStep === 2 ? '16px' : '8px'} />
            <Image src={activeStep === 3 ? iconSelectedellipse : iconEllipse} w={activeStep === 3 ? '12px' : '8px'} h={activeStep === 3 ? '16px' : '8px'} />
            <Image src={activeStep === 4 ? iconSelectedellipse : iconEllipse} w={activeStep === 4 ? '12px' : '8px'} h={activeStep === 4 ? '16px' : '8px'} />
          </HStack>
          <Box>
            <HStack>
              <Button onClick={() => (activeStep !== 4 ? prevStep() : setStep(0))} isFullWidth isDisabled={activeStep === 0}>
                {activeStep === 4 ? 'Corrigir' : 'Voltar'}
              </Button>
              <Button
                onClick={handleNext}
                isFullWidth
                bg={activeStep === 4 ? '#8FC74C' : 'gray.700'}
                color="white"
                isLoading={loading}
                _hover={{ background: activeStep === 4 ? '#81bc3a' : 'gray.800' }}
                _active={{ background: activeStep === 4 ? '#73a734' : 'gray.900' }}
                disabled={disabledButtonSubmit}
              >
                {activeStep === 4 ? 'Está tudo certo!' : 'Próximo'}
              </Button>
            </HStack>
          </Box>
        </Flex>
      </Flex>
      <VStack hidden={activeStep !== 5} w={{ base: '100%', lg: '720px' }} h="100%" spacing={0}>
        <Center flexDir="column" h="100%" mt={2} justifyContent="flex-end" pb={4}>
          <RiThumbUpFill size="40" fill="#D0D0D0" />
          <Text as="h1" mt="4" color="#8FC74C" fontSize={{ base: 'xl', lg: '3xl' }} fontWeight="bold" textAlign="center" lineHeight="28px">
            TRANSPORTADORA
            <br />
            CADASTRADA COM SUCESSO!
          </Text>
        </Center>
        <Image display={{ base: 'none', lg: 'block' }} src={caminhoesparalelos} />
      </VStack>
      <Flex hidden={activeStep !== 5} h="100%" w={{ base: 'unset', lg: 'calc(100% - 720px)' }}>
        <Flex
          py="16"
          pl={{ base: '6', lg: '6' }}
          pr={{ base: '6', lg: '10' }}
          flexDir="column"
          overflow={{ base: 'unset', lg: 'auto' }}
          height={{ base: 'max-content', lg: '100%' }}
          scrollbar-gutter="stable"
          w="100%"
          justify="center"
        >
          <Center>
            <VStack p="3" borderTop="8px solid #4d72ad" boxShadow="0px 5px 10px 0px #00000026;" w="100%" borderBottomRadius="5px" width="max-content" min-width="415px">
              <Stack direction={{ base: 'column', lg: 'row' }} w="100%">
                {logoPreview ? <Image src={logoPreview} alt="logo transportadora" h="134px" maxW="300px" /> : <Image src={logoPlaceholder} />}
                <VStack w="100%" gap="5px" spacing="0" align="flex-start">
                  <Text fontSize="sm" color="#9b9b9b">
                    {getValues('transportador.nomeFantasia')}
                  </Text>
                  <HStack>
                    <MdEmail fill="#5c5c5c" />
                    <Text fontSize="sm" color="#9b9b9b">
                      {getValues('contato.email')}
                    </Text>
                  </HStack>
                  <Stack direction={{ base: 'column', lg: 'row' }}>
                    <HStack>
                      <RiWhatsappFill fill="#5c5c5c" />
                      <Text fontSize="sm" color="#9b9b9b" whiteSpace="nowrap">
                        {getValues('contato.celular')}
                      </Text>
                    </HStack>
                    {getValues('transportador.telefone') && (
                      <HStack>
                        <MdPhone fill="#5c5c5c" />
                        <Text fontSize="sm" color="#9b9b9b" whiteSpace="nowrap">
                          {getValues('transportador.telefone')}
                        </Text>
                      </HStack>
                    )}
                  </Stack>
                  {getValues('transportador.site') && (
                    <HStack>
                      <MdWeb fill="#5c5c5c" />
                      <Text fontSize="sm" color="#9b9b9b">
                        {getValues('transportador.site')}
                      </Text>
                    </HStack>
                  )}
                </VStack>
              </Stack>
              {getValues('observacoesGerais') && (
                <Box border="1px solid #e6e6e6" p="2" w="100%">
                  <Text dangerouslySetInnerHTML={{ __html: getValues('observacoesGerais').replace('\n', '<br />') }} fontSize="sm" color="#9b9b9b" />
                </Box>
              )}
            </VStack>
          </Center>
          <Text mt="12" fontSize="lg">
            A partir de agora, sua transportadora aparecerá como sugestão nas cotações de frete dos embarcadores que usam o Active OnSupply. Quando for selecionado, o cliente entrará em contato
            diretamente com você.
          </Text>
          <br />
          <Text fontWeight="bold" fontSize="lg">
            Obrigado e bons negócios!
          </Text>
          <Box mt="5">
            <Box bg="#182128" p="5">
              <VStack>
                <Text color="white" fontSize="2xl" lineHeight="1.2" fontWeight="bold">
                  PORTAL DO TRANSPORTADOR
                </Text>
                <Text color="#a3abae" fontSize="xs">
                  Assista os vídeos e surpreenda seu embarcador
                </Text>
              </VStack>
            </Box>
            <Box bg="#8FC14E" px="5" py="3">
              <Text as="a" color="white" fontSize="xl" href="https://activecorp.com.br/ajuda/home-3/bem-vindo-ao-onsupply/transportador/">
                Clique aqui e saiba mais!
              </Text>
            </Box>
          </Box>
        </Flex>
      </Flex>
      <VStack hidden={activeStep !== 6} w={{ base: '100%', lg: '720px' }} h="100%" spacing={0}>
        <Center flexDir="column" h="100%" justifyContent="flex-end">
          <Text as="h1" color="#c00000" fontSize={{ base: 'xl', lg: '3xl' }} fontWeight="bold" textAlign="center" lineHeight="28px">
            OPS... VOCÊ JÁ TEM UM CADASTRO
            <br />
            NO PORTAL ACTIVE ONSUPPLY!
          </Text>
        </Center>
        <Text mt="20" fontSize="lg" textAlign="center">
          Por questões de segurança das suas informações, <br /> antes de atualizar seu cadastro, precisamos ter <br /> certeza de que é você mesmo.
        </Text>
        <Image display={{ base: 'none', lg: 'block' }} src={caminhoesparalelos} />
      </VStack>
      <Flex hidden={activeStep !== 6} h="100%" w={{ base: 'unset', lg: 'calc(100% - 720px)' }}>
        <Flex
          py="16"
          pl={{ base: '6', lg: '6' }}
          pr={{ base: '6', lg: '10' }}
          flexDir="column"
          overflow={{ base: 'unset', lg: 'auto' }}
          height={{ base: 'max-content', lg: '100%' }}
          scrollbar-gutter="stable"
          w="100%"
          justify="center"
        >
          <Center>
            <VStack p="3" borderTop="8px solid #4d72ad" boxShadow="0px 5px 10px 0px #00000026;" w="100%" borderBottomRadius="5px" width="max-content" min-width="415px">
              <Stack direction={{ base: 'column', lg: 'row' }} w="100%">
                {logoPreview ? <Image src={logoPreview} alt="logo transportadora" h="134px" maxW="300px" /> : <Image src={logoPlaceholder} />}
                <VStack w="100%" gap="5px" spacing="0" align="flex-start">
                  <Text fontSize="sm" color="#9b9b9b">
                    {getValues('transportador.nomeFantasia')}
                  </Text>
                  <HStack>
                    <MdEmail fill="#5c5c5c" />
                    <Text fontSize="sm" color="#9b9b9b">
                      {getValues('contato.email')}
                    </Text>
                  </HStack>
                  <Stack direction={{ base: 'column', lg: 'row' }}>
                    <HStack>
                      <RiWhatsappFill fill="#5c5c5c" />
                      <Text fontSize="sm" color="#9b9b9b" whiteSpace="nowrap">
                        {getValues('contato.celular')}
                      </Text>
                    </HStack>
                    {getValues('transportador.telefone') && (
                      <HStack>
                        <MdPhone fill="#5c5c5c" />
                        <Text fontSize="sm" color="#9b9b9b" whiteSpace="nowrap">
                          {getValues('transportador.telefone')}
                        </Text>
                      </HStack>
                    )}
                  </Stack>
                  {getValues('transportador.site') && (
                    <HStack>
                      <MdWeb fill="#5c5c5c" />
                      <Text fontSize="sm" color="#9b9b9b">
                        {getValues('transportador.site')}
                      </Text>
                    </HStack>
                  )}
                </VStack>
              </Stack>
              {getValues('observacoesGerais') && (
                <Box border="1px solid #e6e6e6" p="2" w="100%">
                  <Text dangerouslySetInnerHTML={{ __html: getValues('observacoesGerais').replace('\n', '<br />') }} fontSize="sm" color="#9b9b9b" />
                </Box>
              )}
            </VStack>
          </Center>
          <Text mt="12" fontSize="lg" textAlign="center">
            Identificamos que já existe um cadastro com o <br /> CNPJ {getValues('transportador.cnpj')}.
          </Text>
          <Text mt="2" fontSize="lg" textAlign="center">
            Se deseja atualizar seu cadastro com as novas informações <br /> confirme pelo e-mail que enviamos para:
          </Text>
          <Text mt="2" fontSize="lg" textAlign="center" fontWeight="bold">
            {emailConfirmacao}
          </Text>
          <br />
          <Box mt="5">
            <Box bg="#182128" p="5">
              <VStack>
                <Text color="white" fontSize="18">
                  Ou entre em contato com nossa equipe de
                </Text>
                <Text color="white" fontSize="2xl" lineHeight="1.2" fontWeight="bold">
                  Sucesso do Cliente:
                </Text>
              </VStack>
            </Box>
            <Box bg="#8FC14E" px="5" py="3" textAlign="center">
              <Text as="a" color="white" fontSize="xl">
                (11) 2229-0810
              </Text>
              <br />
              <Text as="a" color="white" fontSize="xl">
                cs@activecorp.com.br
              </Text>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Stack>
  );
}

export { CadastroTransportadoraFreteApp };
